<template>
  <div v-if="isShow">
    <div v-if="isCheckedAutoInputMsgTemplate">
      <header>
        メッセージテンプレート
        <div class="h-left">
          <a @click="close"
            ><img src="~@/assets/images/icon02.svg"
          /></a>
        </div>
      </header>
      <div id="wrap">
        <div class="txt-area">
          <p class="b">自動挿入設定</p>
          <p>
            一通目のメッセージは送信時に保存したメッセージが自動で挿入されます。
          </p>
        </div>
        <div class="porf-area">
          <table>
            <tr>
              <td class="b">テンプレートを自動挿入</td>
              <td class="right">
                <div class="switch3">
                  <label class="switch3__label"
                    ><input
                      @change="checkStatus"
                      v-model="formData.status"
                      id="auto_input_msg_template"
                      type="checkbox"
                      class="switch3__input" /><span
                      class="switch3__content"
                    ></span
                    ><span class="switch3__circle"></span
                  ></label>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="txt-area">
          <p class="b">メッセージテンプレート</p>
          <p>
            一通目のメッセージは送信時に保存したメッセージが自動で挿入されます。
          </p>
        </div>
        <a href="#">
          <div style="word-break: break-word;" class="template02" id="msg_template" @click="openEdit()">
            {{ content }}
          </div>
        </a>
        <div :class="isChange ? 'btn1' : 'btn3'">
          <a href="#" @click="saveMsgTemplate()">保存する</a>
        </div>
      </div>
    </div>
    <div v-if="isShowInputMsgTemplate">
      <header>
        メッセージテンプレート
        <div class="h-left">
          <a
            @click="
              isValid = false;
              isShowInputMsgTemplate = false;
              isCheckedAutoInputMsgTemplate = true;
              formData.body = null;
            "
          >
            <img src="~@/assets/images/icon02.svg" />
          </a>
        </div>
      </header>
      <div id="wrap">
        <div class="txt-area">
          <p class="b">メッセージテンプレート</p>
          <textarea
            @keyup="checkChangeContent"
            v-model="formData.body"
            id="input_msg_template"
            class="self-introduction1"
            placeholder="10文字以上入力してください"
            maxlength="200"
          ></textarea>

          <div class="clearfix content">
            <p v-if="isValid" style="color: red">10文字以上ご記入ください</p>
            <div class="self-introduction3">
              {{ formData.body ? formData.body.length : 0 }}/200
            </div>
          </div>
          <div :class="isChangeContent && formData.body ? 'btn1' : 'btn3'">
            <a href="#" @click="saveContent()">保存する</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <alertDialogBottom :active="isAlert">
      変更しました。
  </alertDialogBottom>
  <questionDialog :active="isShowQuestionExit" @close="isShowQuestionExit = false" @exit="exitQuestionDialog">
      更新した内容は保存されていません。このまま戻りますか？
  </questionDialog>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
import questionDialog from "@/views/components/questionDialog"
export default {
  props: {
    isShow: Boolean,
  },
  emits: ['close'],
  components: {
    alertDialogBottom,
    questionDialog
  },
  data: () => ({
    isShowInputMsgTemplate: false,
    isCheckedAutoInputMsgTemplate: true,
    formData: {
      status: false,
      body: '',
    },
    content: '',
    isChange: false,
    isValid: false,
    isAlert: false,
    isChangeContent: false,
    isShowQuestionExit: false,
    isLoading: false
  }),
  mounted() {
    this.loadMessageTemplateSetting();
  },
  computed: {
    ...mapGetters(["metadata", "defaultToken"]),
  },
  methods: {
    checkStatus() {
      this.isChange = true;
    },
    checkChangeContent() {
        this.isChangeContent = true
    },
    openEdit() {
      this.formData.body = this.content;
      this.isShowInputMsgTemplate = true;
      this.isCheckedAutoInputMsgTemplate = false;
    },
    loadMessageTemplateSetting() {
      this.isLoading = true
      this.$store
        .dispatch("user/getMessageTemplate", {
          token: this.defaultToken,
        })
        .then((data) => {
          this.isLoading = false
          if (data[0]) {
            if (parseInt(data[0].status) === 1) {
              this.formData.status = true;
            } else {
              this.formData.status = false;
            }
            this.content = data[0].body;
            this.isChange = false
            this.isChangeContent = false
          }
        })
        .catch((err) => {
          this.isLoading = false
          console.log(err);
        });
    },
    saveContent() {
      if (!this.isChangeContent || !this.formData.body) {
        return;
      }
      if (this.formData.body && this.formData.body.length < 10) {
        this.isValid = true;
        return;
      }
      this.isShowInputMsgTemplate = false;
      this.isCheckedAutoInputMsgTemplate = true;
      this.isChange = true
      this.content = this.formData.body;
      this.isValid = false;
    },
    saveMsgTemplate() {
      if (!this.isChange)  return;
      let formData = new FormData();
      if (this.formData.status) {
        formData.append("status", 1);
      } else {
        formData.append("status", 0);
      }
    //   formData.append("status", this.formData.status);
      formData.append("body", this.content);
      formData.append("token", this.defaultToken);

      // for (var pair of formData.entries()) {
      //     console.log(pair[0]+ ', ' + pair[1]); 
      // }

      this.$store
        .dispatch("user/saveMessageTemplate", formData)
        .then((data) => {
        //   this.isShowInputMsgTemplate = false;
        //   this.isCheckedAutoInputMsgTemplate = true;
          this.isChange = false;
          this.isAlert = true
                
          setTimeout(() => {
              this.isAlert = false
          }, 1000)
          this.isChangeContent = false
        //   this.content = this.formData.body;
        })
        .catch((err) => {
        //   console.log(err);
        });
    },
    close() {
        if (this.isChange) {
            this.isShowQuestionExit = true
        } else {
            this.$emit('close')
            this.content = ''
        }
    },
    exitQuestionDialog() {
      this.$emit('close')
      this.isShowQuestionExit = false
      this.content = ''
    }
  },
};
</script>
<style scoped>
.content {
  display: flex;
  position: relative;
}
.content div {
  right: 0;
  text-align: right;
  position: absolute;
}
</style>
